export default {
  title: 'Controller status:',
};
